import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconAutofitHeightDotted$1 = /*@__PURE__*/ proxyCustomElement(class WppIconAutofitHeightDotted extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-autofit-height-dotted", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M15.7121 5.23289L14.2508 3.71976L12.7895 5.23289C12.5017 5.53084 12.0269 5.53911 11.729 5.25137C11.431 4.96362 11.4228 4.48882 11.7105 4.19087L13.5315 2.30532C13.9246 1.89823 14.577 1.89823 14.9701 2.30532L16.7911 4.19087C17.0788 4.48882 17.0705 4.96362 16.7726 5.25137C16.4746 5.53911 15.9998 5.53084 15.7121 5.23289ZM15.7121 14.7671L14.2508 16.2802L12.7895 14.7671C12.5017 14.4691 12.0269 14.4609 11.729 14.7486C11.431 15.0364 11.4228 15.5112 11.7105 15.8091L13.5315 17.6947C13.9246 18.1018 14.577 18.1018 14.9701 17.6947L16.7911 15.8091C17.0788 15.5112 17.0705 15.0364 16.7726 14.7486C16.4746 14.4609 15.9998 14.4691 15.7121 14.7671ZM14.2527 12C14.667 12 15.0027 12.3358 15.0027 12.75V13.25C15.0027 13.6642 14.667 14 14.2527 14C13.8385 14 13.5027 13.6642 13.5027 13.25V12.75C13.5027 12.3358 13.8385 12 14.2527 12ZM15.0027 10.25C15.0027 10.6642 14.667 11 14.2527 11C13.8385 11 13.5027 10.6642 13.5027 10.25V9.75C13.5027 9.33579 13.8385 9 14.2527 9C14.667 9 15.0027 9.33579 15.0027 9.75V10.25ZM14.2527 8C14.667 8 15.0027 7.66421 15.0027 7.25V6.75C15.0027 6.33579 14.667 6 14.2527 6C13.8385 6 13.5027 6.33579 13.5027 6.75V7.25C13.5027 7.66421 13.8385 8 14.2527 8ZM5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H9.25C9.66421 17 10 16.6642 10 16.25C10 15.8358 9.66421 15.5 9.25 15.5H5C4.72386 15.5 4.5 15.2761 4.5 15V5C4.5 4.72386 4.72386 4.5 5 4.5H9.25C9.66421 4.5 10 4.16421 10 3.75C10 3.33579 9.66421 3 9.25 3H5Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-autofit-height-dotted-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-autofit-height-dotted", "wpp-icon-autofit-height-dotted-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-autofit-height-dotted-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-autofit-height-dotted-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconAutofitHeightDotted$1);
      }
      break;
  } });
}

const WppIconAutofitHeightDotted = WppIconAutofitHeightDotted$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconAutofitHeightDotted, defineCustomElement };
